// Lead sources, shared by the contact form and the project form.
//
// Two representations, deliberately:
//   index  — Customer.LeadSource is an int-backed enum on the contact
//   value  — Project.LeadSource is free text, and four live automations match it
//            as a STRING (e.g. leadSource equals "Property Management"). The
//            strings below are those exact values; changing one silently stops
//            those rules matching, with no error anywhere.
export const LEAD_SOURCES = [
  { index: 0, key: 'Google',             value: 'Google',              label: 'Google' },
  { index: 1, key: 'Referral',           value: 'Referral',            label: 'Referral' },
  { index: 2, key: 'PropertyManagement', value: 'Property Management', label: 'Property Management' },
  { index: 3, key: 'Warranty',           value: 'Warranty',            label: 'Warranty' },
  { index: 4, key: 'Progress',           value: 'Progress',            label: 'Progress' },
  { index: 5, key: 'Other',              value: 'Other',               label: 'Other' },
  { index: 6, key: 'Spotio',             value: 'Spotio',              label: 'Spotio' },
];

// A contact's enum value → the string a project stores.
export const leadSourceValueFromIndex = (index) =>
  LEAD_SOURCES.find((s) => s.index === index)?.value ?? '';

export const LEAD_SOURCE_VALUES = LEAD_SOURCES.map((s) => s.value);
